import {AnimationProvider, Box, Heading, Grid, Link, SectionIntro, Stack, Text} from '@primer/react-brand'
import {analyticsEvent} from '../../../../lib/analytics'
import {Image} from '../../../../components/Image/Image'
import CopilotIconAnimation from './CopilotIconAnimation'

export default function ProductivitySection() {
  return (
    <section id="productivity" className="lp-Section lp-Section--compact lp-Section--level-gradient lp-Section--illu">
      <Grid className="lp-Section-container--centerUntilMedium lp-Grid--noRowGap lp-Section--illu-content">
        <Grid.Column span={12}>
          <SectionIntro fullWidth align="center" className="lp-SectionIntro" style={{gap: '0'}}>
            <CopilotIconAnimation />
            <SectionIntro.Heading size="3" weight="semibold">
              The industry <br className="break-whenNarrow" /> standard
            </SectionIntro.Heading>
          </SectionIntro>
        </Grid.Column>

        <Grid.Column span={12}>
          <AnimationProvider runOnce>
            <Box
              padding={32}
              className="lp-Productivity-item has-BlurredBg has-GradientBorder"
              marginBlockEnd={32}
              animate="slide-in-up"
            >
              <Image
                src="/images/modules/site/copilot/quote.svg"
                alt=""
                width="44"
                height="35"
                className="lp-ProductivityTestimonial-quote-icon"
              />

              <Text size="600" weight="medium" className="lp-ProductivityTestimonial-quote">
                <span className="lp-ProductivityTestimonial-quote-highlight">
                  Personalized, natural language recommendations are now at the fingertips of all our developers at
                  Figma.
                </span>{' '}
                Our engineers are coding faster, collaborating more effectively, and building better outcomes.
              </Text>

              <Stack
                direction={{narrow: 'vertical', regular: 'horizontal'}}
                gap={16}
                padding={'none'}
                style={{alignItems: 'center'}}
              >
                <Image
                  src="/images/modules/site/copilot/logo-framer.svg"
                  alt=""
                  width="33"
                  height="48"
                  className="lp-ProductivityTestimonial-logo"
                />
                <Stack direction="vertical" gap="none" padding="none">
                  <Text as="p" weight="medium">
                    Tommy MacWilliam
                  </Text>
                  <Text as="p" weight="medium" variant="muted" className="text-mono">
                    Engineering Manager for Infrastructure @ Figma
                  </Text>
                </Stack>
              </Stack>
            </Box>

            <Stack
              direction={{narrow: 'vertical', regular: 'horizontal'}}
              gap={32}
              padding="none"
              className="lp-Productivity"
            >
              <Box
                padding={32}
                className="lp-Productivity-item has-BlurredBg has-GradientBorder width-full"
                animate="slide-in-up"
              >
                <Heading
                  as="h3"
                  weight="medium"
                  className="is-sansSerifAlt"
                  style={{fontSize: '48px', letterSpacing: '-0.03em', lineHeight: '1'}}
                >
                  77,000+
                </Heading>
                <Text as="p" weight="medium" variant="muted" style={{fontSize: '18px'}}>
                  Businesses have adopted GitHub Copilot
                </Text>
              </Box>

              <Box
                padding={32}
                className="lp-Productivity-item has-BlurredBg has-GradientBorder width-full"
                animate="slide-in-up"
              >
                <Heading
                  as="h3"
                  weight="medium"
                  className="is-sansSerifAlt"
                  style={{fontSize: '48px', letterSpacing: '-0.03em', lineHeight: '1'}}
                >
                  55%
                </Heading>
                <Text as="p" weight="medium" variant="muted" style={{fontSize: '18px'}}>
                  Developer preference for GitHub Copilot
                </Text>
                <Text size="100" variant="muted" style={{marginTop: '28px'}}>
                  Stack Overflow 2023 Survey
                </Text>
              </Box>
              <Box
                padding={32}
                className="lp-Productivity-item has-BlurredBg has-GradientBorder width-full"
                animate="slide-in-up"
              >
                <Heading
                  as="h3"
                  weight="medium"
                  className="is-sansSerifAlt"
                  style={{fontSize: '48px', letterSpacing: '-0.03em', lineHeight: '1'}}
                >
                  3B+
                </Heading>
                <Text as="p" weight="medium" variant="muted" style={{fontSize: '18px'}}>
                  Accepted lines of code
                  <sup>
                    <a id="footnote-ref-1-1" href="#footnote-1">
                      1
                    </a>
                  </sup>
                </Text>
              </Box>
            </Stack>

            <Box
              padding={32}
              className="lp-Productivity-item has-BlurredBg has-GradientBorder"
              marginBlockStart={32}
              animate="slide-in-up"
              style={{alignItems: 'flex-start'}}
            >
              <Image
                src="/images/modules/site/copilot/logo-gartner.svg"
                alt="Gartner"
                width="99"
                height="23"
                className="lp-ProductivityBox-logo"
              />

              <Text size="600" weight="medium" className="lp-ProductivityTestimonial-quote">
                GitHub: A Leader in the 2024 Gartner® Magic Quadrant™ <br /> for AI Code Assistants
              </Text>

              <Link
                href="https://www.gartner.com/doc/reprints?id=1-2IKO4MPE&ct=240819&st=sb"
                variant="accent"
                size="large"
                target="_blank"
                {...analyticsEvent({
                  action: 'gartner_doc',
                  tag: 'link',
                  context: 'gartner_report_copilot',
                  location: 'stats',
                })}
              >
                Read the report
              </Link>
            </Box>
          </AnimationProvider>
        </Grid.Column>
      </Grid>

      <Image
        src="/images/modules/site/copilot/productivity-bg.webp"
        alt=""
        width="961"
        height="691"
        className="lp-Productivity-bg"
      />
    </section>
  )
}

try{ ProductivitySection.displayName ||= 'ProductivitySection' } catch {}